import { ModalWithVersion } from '@/components/core/Modal/WithVersion';
import { ModalsKey } from '@/enums/modalsKey';
import { RewardId } from '@/enums/reward-id';
import { useModal } from '@/hooks/modals/useModal';
import { useSearchParams } from '@/hooks/useSearchParams';
import useTranslation from 'next-translate/useTranslation';
import ClaimRewardModalContent from './Content';

export default function ClaimRewardModal() {
  const { t } = useTranslation('bonus');
  const { isOpen } = useModal(ModalsKey.ClaimReward);
  const search = useSearchParams();
  const rewardId = search.get('reward-id');

  return (
    <ModalWithVersion
      condition={
        isOpen &&
        !!rewardId &&
        rewardId?.toString() !== RewardId.LuckyWheel?.toString()
      }
      title={t(`${rewardId}_reward_name`)}
      modal={ModalsKey.ClaimReward}
    >
      <ClaimRewardModalContent />
    </ModalWithVersion>
  );
}
